import TagManager from 'react-gtm-module';

export default {
  init: function() {
    TagManager.initialize({ gtmId: 'GTM-N2HNLNWV' });
  },
  push: function(obj: {}) {
    TagManager.dataLayer({
        dataLayer: obj
    })
  }
}
